// extracted by mini-css-extract-plugin
export var headerCell = "_4f-1";
export var loadingSpinnerContainer = "_4f-4";
export var rowWrapper = "_4f-3";
export var standaloneTable = "_4f-5";
export var table = "_4f-0";
export var white = "_4f-2";